import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';

export function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = (type: 'all' | 'essential') => {
    const consent = {
      essential: true,
      analytics: type === 'all',
      marketing: type === 'all',
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -100, opacity: 0 }}
        className="fixed bottom-20 left-4 z-[999] max-w-sm"
        role="dialog"
        aria-labelledby="cookie-consent-title"
        aria-describedby="cookie-consent-description"
      >
        <div className="bg-white rounded-xl shadow-2xl p-4 border border-gray-200">
          <div className="flex items-start gap-3 mb-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <Cookie className="h-4 w-4 text-blue-600" />
              </div>
            </div>
            <div className="flex-1">
              <h2 id="cookie-consent-title" className="text-sm font-bold text-gray-900 mb-1">
                שימוש בעוגיות
              </h2>
              <p id="cookie-consent-description" className="text-xs text-gray-600 leading-relaxed">
                אנו משתמשים בעוגיות לשיפור החוויה.
              </p>
            </div>
          </div>

          {showDetails && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              className="mb-3 p-3 bg-gray-50 rounded-lg space-y-2 text-xs"
            >
              <div>
                <span className="font-semibold text-gray-900">חיוניות:</span>
                <span className="text-gray-600"> נדרשות לתפקוד האתר</span>
              </div>
              <div>
                <span className="font-semibold text-gray-900">אנליטיות:</span>
                <span className="text-gray-600"> לשיפור השירות</span>
              </div>
            </motion.div>
          )}

          <div className="flex flex-col gap-2">
            <button
              onClick={() => handleAccept('all')}
              className="w-full px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all"
              aria-label="אישור שימוש בכל העוגיות"
            >
              אני מסכים
            </button>
            <div className="flex gap-2">
              <button
                onClick={() => handleAccept('essential')}
                className="flex-1 px-3 py-1.5 bg-gray-200 text-gray-700 text-xs font-medium rounded-lg hover:bg-gray-300 transition-all"
                aria-label="אישור עוגיות חיוניות בלבד"
              >
                חיוניות בלבד
              </button>
              <button
                onClick={() => setShowDetails(!showDetails)}
                className="flex-1 px-3 py-1.5 text-blue-600 hover:text-blue-700 text-xs font-medium"
                aria-label={showDetails ? 'הסתר פרטים' : 'הצג פרטים'}
              >
                {showDetails ? 'הסתר' : 'פרטים'}
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
